import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import ActionButton from '../ActionButton'

export enum BannerTitleTextButtonVariant {
  primary = 'primary',
  secondary = 'secondary',
}

export const BannerTitleTextButton = styled.div<{
  $variant?: BannerTitleTextButtonVariant
}>`
  background-color: ${({ theme, $variant }) =>
    !$variant || $variant === BannerTitleTextButtonVariant.primary
      ? theme.colors.blueBack
      : $variant === BannerTitleTextButtonVariant.secondary
      ? theme.colors.bluePrimary
      : theme.colors.pureWhite};
  color: ${({ theme, $variant }) =>
    !$variant || $variant === BannerTitleTextButtonVariant.primary
      ? theme.colors.blueSecondaryBis
      : $variant === BannerTitleTextButtonVariant.secondary
      ? theme.colors.pureWhite
      : theme.colors.pureWhite};
  padding: 3.5rem 2rem;

  @media ${mq(sizes.tablet)} {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10rem;
  }
`

export const Wrapper = styled.div`
  max-width: 53rem;
`

export const Title = styled.h3`
  ${({ theme }) => theme.textStyles.firaSansXlBold};
  margin: 0 0 0.5rem 0;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBase}
`

export const Button = styled(ActionButton)`
  @media ${mq(null, sizes.tablet)} {
    margin-top: 2rem;
  }
`
